import React, { useState, useCallback } from "react";
import { DataTableFilterMeta } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";

export const useFilters = () => {
  const [filters, setFilters] = useState<DataTableFilterMeta>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: {
      operator: "and",
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    city: {
      operator: "and",
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    address: {
      operator: "and",
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    status: {
      operator: "or",
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    isReservable: {
      operator: "or",
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const initFilters = useCallback(() => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      id: {
        operator: "and",
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      city: {
        operator: "and",
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      address: {
        operator: "and",
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      status: {
        operator: "or",
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      isReservable: {
        operator: "or",
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    });
    setGlobalFilterValue("");
  }, []);

  const onGlobalFilterChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setFilters((prev) => ({ ...prev, global: { ...prev.global, value } }));
      setGlobalFilterValue(value);
    },
    []
  );

  return { filters, globalFilterValue, initFilters, onGlobalFilterChange };
};
